import {RouteItemConfig} from "../models";
import DashboardView from "../../views/home/dashboard/dashboardView";
import TasksGridView from "views/home/tasks/TasksGridView";
import {Outlet} from "react-router-dom";
import CoursesGridView from "views/home/courses/CourseGridView";
import OrdersGridView from "views/home/orders/OrdersGridView";
import AuthorsGridView from "views/home/authorsManagement/authors/AuthorsGridView";
import AuthorsPaymentsGridView from "views/home/authorsManagement/authorsPayments/AuthorsPaymentsGridView";
import FormTemplatesGridView from "views/home/formTemplates/FormTemplatesGridView";
import ScientificPublicationGridView from "views/home/scientificPublication/ScientificPublicationGridView";
import JudgesGridView from "views/home/judgesManagement/judges/JudgesGridView";
import JudgesRewardsGridView from "views/home/judgesManagement/judgesRewards/JudgesRewardsGridView";
import ExaminersRewardsGridView from "views/home/examinersManagement/examinersRewards/ExaminersRewardsGridView";
import ExaminersGridView from "views/home/examinersManagement/examiners/ExaminersGridView";
import CourseForm from "views/home/courses/CourseForms";
import CourseView from "views/home/courses/CourseView";
import UserProfile from "views/home/userProfile";
import ScientificPublicationForm from "views/home/scientificPublication/form/ScientificPublicationForm";
import PublicationView from "views/home/scientificPublication/PublicationView";
import EvaluationFormsGridView from "../../views/home/evaluationForms/EvaluationFormsGridView.tsx";
import EvaluationFormAddUpdateView from "../../views/home/evaluationForms/FormView";
import FormTemplateFormAddUpdateView from "views/home/formTemplates/FormView";
import OrderForm from "views/home/orders/OrderForm";
import CourseOrderAdminView from "views/home/orders/OrderView/UserTypeOrderView/CourseOrderAdminView";
import MyPublishedWorkGrid from "views/home/authorOrders/MyPublishedWorkGrid";
import MyAllOrdersGridView from "views/home/authorOrders/MyAllOrdersGridView";
import ViewPublishedCourseOrder from "views/home/authorOrders/MyPublishedWorkGrid/ViewPublishedCourseOrder";
import ViewUnPublishedCourseOrder from "views/home/authorOrders/MyAllOrdersGridView/ViewUnPublishedCourseOrder";
import EditUserProfileForm from "views/home/userProfile/EditUserProfileForm";
import CourseOrderResearchCenterManagerView
    from "views/home/orders/OrderView/UserTypeOrderView/CourseOrderResearchCenterManagerView";
import ScientificPublishingUnitOrderView
    from "../../views/home/orders/OrderView/UserTypeOrderView/ScientificPublishingUnitOrderView";
import UpdateAutherOrderView from "../../views/home/orders/OrderView/UserTypeOrderView/UpdateAuthorOrderView";
import ExaminerTaskView from "views/home/tasks/ExaminerTaskView";
import GenericWorkFlowOrderView from "../../views/home/orders/OrderView/UserTypeOrderView/GenericWorkFlowOrderView";
import CourseOrderRefereeManagementView
    from "../../views/home/orders/OrderView/UserTypeOrderView/CourseOrderRefereeManagementView";
import RefereeTaskView from "../../views/home/tasks/RefereeTaskView";
import PublishingHouseOrderView from "../../views/home/orders/OrderView/UserTypeOrderView/PublishingHouseOrderView";
import DisbursementRecommendationOrderView
    from "../../views/home/orders/OrderView/UserTypeOrderView/DisbursementRecommendationOrderView";
import CourseOrderPublishingHourseOrderView
    from "../../views/home/orders/OrderView/UserTypeOrderView/CourseOrderPublishingHourseOrderView";
import {getUserSession} from "../../helpers/UserInfo";
import ExaminersCompletedTasksGridView
    from "../../views/home/examinersCompletedTasksGridView/ExaminersCompletedTasksGridView";
import ExaminersRewards from "../../views/home/examinerRewards";
import RefereeRewards from "../../views/home/refereeRewards";
import UpdateAuthorRdmkOrderView from "../../views/home/orders/OrderView/UserTypeOrderView/UpdateAuthorRdmkOrderView";
import PostAnnouncementOrderView from "../../views/home/orders/OrderView/UserTypeOrderView/PostAnnouncementOrderView";
import ExaminerCompleteOrderView from "../../views/home/examinersCompletedTasksGridView/ExaminerCompletedOrderView";
import {
    CompletedCourseOrderTaskDetails
} from "../../views/home/examinersCompletedTasksGridView/CompletedCourseOrderTaskDetails";

export const HomeRoutes: RouteItemConfig[] = [
    {
        path: "/home/dashboard",
        name: "dashboard",
        component: DashboardView,
        icon: "icon-dashboard",
        layout: "/home",
        default: true,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingDashboardRead',
            'PublishingDashboardWrite',
            'PublishingDashboardDelete',
            'PublishingDashboardAcceptReject',
            'PublishingDashboardCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/courses",
        name: "allCourses",
        component: CoursesGridView,
        icon: "icon-programs",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingAllCoursesRead',
            'PublishingAllCoursesWrite',
            'PublishingAllCoursesDelete',
            'PublishingAllCoursesAcceptReject',
            'PublishingAllCoursesCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/courses/form",
        name: "courseForm",
        component: CourseForm,
        icon: "icon-programs",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingAllCoursesCreate',
            'PublishingAllCoursesWrite'
        ],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/courses/:courseId",
        name: "courseView",
        component: CourseView,
        icon: "icon-programs",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    // {
    //     path: "/home/authorOrders",
    //     name: "authorOrders",
    //     component: Outlet,
    //     icon: "icon-orders",
    //     layout: "/home",
    //     default: false,
    //     isExact: true,
    //     authorize: true,
    //     roles: [
    //         'PublishingMyPublishedWorkRead',
    //         'PublishingMyPublishedWorkWrite',
    //         'PublishingMyPublishedWorkDelete',
    //         'PublishingMyPublishedWorkAcceptReject',
    //         'PublishingMyPublishedWorkCreate',
    //         'PublishingMyAllOrdersRead',
    //         'PublishingMyAllOrdersWrite',
    //         'PublishingMyAllOrdersDelete',
    //         'PublishingMyAllOrdersAcceptReject',
    //         'PublishingMyAllOrdersCreate',
    //     ],
    //     subMenu: [
    //         {
    //             path: "/home/authorOrders/MyPublishedWork",
    //             name: "myPublishedWork",
    //             component: MyPublishedWorkGrid,
    //             layout: "/home",
    //             default: false,
    //             isExact: true,
    //             authorize: true,
    //             roles: [
    //                 'PublishingMyPublishedWorkRead',
    //                 'PublishingMyPublishedWorkWrite',
    //                 'PublishingMyPublishedWorkDelete',
    //                 'PublishingMyPublishedWorkAcceptReject',
    //                 'PublishingMyPublishedWorkCreate',
    //             ],
    //             showInMenu: true,
    //             isRoute: true,
    //             id: 1,
    //             groupName: "essentials",
    //         },
    //     
    //     ],
    //     showInMenu: true,
    //     isRoute: true,
    //     id: 1,
    //     groupName: "essentials",
    // },

    {
        path: "/home/authorOrders/MyAllOrders",
        name: "authorOrders",
        icon: "icon-orders",
        component: MyAllOrdersGridView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingMyAllOrdersRead',
            'PublishingMyAllOrdersWrite',
            'PublishingMyAllOrdersDelete',
            'PublishingMyAllOrdersAcceptReject',
            'PublishingMyAllOrdersCreate',
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/orders",
        name: "allOrders",
        component: OrdersGridView,
        icon: "icon-orders",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingAllOrdersRead',
            'PublishingAllOrdersWrite',
            'PublishingAllOrdersDelete',
            'PublishingAllOrdersAcceptReject',
            'PublishingAllOrdersCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/orders/add",
        name: "orderView",
        component: OrderForm,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [  'PublishingMyAllOrdersCreate'],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/orders/PublishingHouseOrder",
        name: "PublishingHouseOrder",
        component: () => <OrderForm isPublishingHouse={true}/>,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: ['PublishingMyAllOrdersCreate'],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },


    {
        path: "/home/orders/edit/:orderId",
        name: "orderView",
        component: OrderForm,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/orders/:orderId",
        name: "orderView",
        component: CourseOrderAdminView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/orders/researchCenterManager/:serialGID",
        name: "orderView",
        component: CourseOrderResearchCenterManagerView,
        icon: "icon-orders",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/publishedOrder/:orderId",
        name: "orderView",
        component: ViewPublishedCourseOrder,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/orders/unpublishedOrder/:orderId",
        name: "orderView",
        component: ViewUnPublishedCourseOrder,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/tasks",
        name: "tasks",
        component: TasksGridView,
        icon: "icon-tasks",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            // 'PublishingTasksRead',
            // 'PublishingTasksWrite',
            // 'PublishingTasksDelete',
            // 'PublishingTasksAcceptReject',
            // 'PublishingTasksCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/completedTasks",
        name: "completedTasks",
        component: ExaminersCompletedTasksGridView,
        icon: "icon-tasks",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            // 'PublishingCompletedTasksRead',
            // 'PublishingCompletedTasksWrite',
            // 'PublishingCompletedTasksDelete',
            // 'PublishingCompletedTasksAcceptReject',
            // 'PublishingCompletedTasksCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/centerManagerOrders",
        name: "centerManagerOrders",
        component: () => <OrdersGridView
            centreManagerId={getUserSession()?.id}
            breadcrumbs={[{
                localizationKey: "centerManagerOrders",
                path: "/home/centerManagerOrders",
                menuItemId: "allOrders",
            }]}
        />,
        icon: "icon-orders",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingCenterManagerOrdersRead',
            'PublishingCenterManagerOrdersWrite',
            'PublishingCenterManagerOrdersDelete',
            'PublishingCenterManagerOrdersAcceptReject',
            'PublishingCenterManagerOrdersCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/ExaminersRewards",
        name: "ExaminersRewards",
        component: ExaminersRewards,
        icon: "icon-payment",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingExaminersRewardsRead',
            'PublishingExaminersRewardsWrite',
            'PublishingExaminersRewardsDelete',
            'PublishingExaminersRewardsAcceptReject',
            'PublishingExaminersRewardsCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/RefereeRewards",
        name: "RefereeRewards",
        component: RefereeRewards,
        icon: "icon-payment",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingRefereeRewardsRead',
            'PublishingRefereeRewardsWrite',
            'PublishingRefereeRewardsDelete',
            'PublishingRefereeRewardsAcceptReject',
            'PublishingRefereeRewardsCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/authorsManagement",
        name: "authorsManagement",
        component: Outlet,
        icon: "icon-researchers",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingAuthorsManagementRead',
            'PublishingAuthorsManagementWrite',
            'PublishingAuthorsManagementDelete',
            'PublishingAuthorsManagementAcceptReject',
            'PublishingAuthorsManagementCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
        subMenu: [
            {
                path: "/home/authorsManagement/authors",
                name: "authorsInfo",
                component: AuthorsGridView,
                icon: "icon-researchers",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [
                    'PublishingAuthorsInfoRead',
                    'PublishingAuthorsInfoWrite',
                    'PublishingAuthorsInfoDelete',
                    'PublishingAuthorsInfoAcceptReject',
                    'PublishingAuthorsInfoCreate',
                ],
                showInMenu: true,
                isRoute: true,
                id: 1,
                groupName: "essentials",
            },
            {
                path: "/home/authorsManagement/authors/view",
                name: "authorInfo",
                component: UserProfile,
                icon: "icon-researchers",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [],
                showInMenu: false,
                isRoute: true,
                id: 1,
            },
            {
                path: "/home/authorsManagement/authorPayments",
                name: "authorsPayments",
                component: AuthorsPaymentsGridView,
                icon: "icon-dashboard",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [
                    'PublishingAuthorsPaymentsRead',
                    'PublishingAuthorsPaymentsWrite',
                    'PublishingAuthorsPaymentsDelete',
                    'PublishingAuthorsPaymentsAcceptReject',
                    'PublishingAuthorsPaymentsCreate',
                ],
                showInMenu: true,
                isRoute: true,
            },
        ],
    },
    {
        path: "/home/examinersManagement",
        name: "examinersManagement",
        component: Outlet,
        icon: "icon-researchers",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingExaminersManagementWrite',
            'PublishingExaminersManagementDelete',
            'PublishingExaminersManagementAcceptReject',
            'PublishingExaminersManagementCreate',
            'PublishingExaminersInfoRead',
            'PublishingExaminersInfoWrite',
            'PublishingExaminersInfoDelete',
            'PublishingExaminersInfoAcceptReject',
            'PublishingExaminersInfoCreate',
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
        subMenu: [
            {
                path: "/home/examinersManagement/examiners",
                name: "examinersInfo",
                component: ExaminersGridView,
                icon: "icon-researcher",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [
                    'PublishingExaminersInfoRead',
                    'PublishingExaminersInfoWrite',
                    'PublishingExaminersInfoDelete',
                    'PublishingExaminersInfoAcceptReject',
                    'PublishingExaminersInfoCreate',
                    'PublishingExaminerRewardsRead',
                    'PublishingExaminerRewardsWrite',
                    'PublishingExaminerRewardsDelete',
                    'PublishingExaminerRewardsAcceptReject',
                    'PublishingExaminerRewardsCreate',
                ],
                showInMenu: true,
                isRoute: true,
            },
            {
                path: "/home/examinersManagement/examiners/view",
                name: "researcherInfo",
                component: UserProfile,
                icon: "icon-researchers",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [],
                showInMenu: false,
                isRoute: true,
                id: 1,
            },
            {
                path: "/home/examinersManagement/examinerRewards",
                name: "examinerRewards",
                component: ExaminersRewardsGridView,
                icon: "icon-dashboard",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [
                    'PublishingExaminerRewardsRead',
                    'PublishingExaminerRewardsWrite',
                    'PublishingExaminerRewardsDelete',
                    'PublishingExaminerRewardsAcceptReject',
                    'PublishingExaminerRewardsCreate',
                ],
                showInMenu: true,
                isRoute: true,
            },
        ],
    },
    {
        path: "/home/judgesManagement",
        name: "judgesManagement",
        component: Outlet,
        icon: "icon-researchers",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingJudgesManagementRead',
            'PublishingJudgesManagementWrite',
            'PublishingJudgesManagementDelete',
            'PublishingJudgesManagementAcceptReject',
            'PublishingJudgesManagementCreate',
            'PublishingJudgesInfoRead',
            'PublishingJudgesInfoWrite',
            'PublishingJudgesInfoDelete',
            'PublishingJudgesInfoAcceptReject',
            'PublishingJudgesInfoCreate',
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
        subMenu: [
            {
                path: "/home/judgesManagement/judges",
                name: "judgesInfo",
                component: JudgesGridView,
                icon: "icon-researchers",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [
                    'PublishingJudgesInfoRead',
                    'PublishingJudgesInfoWrite',
                    'PublishingJudgesInfoDelete',
                    'PublishingJudgesInfoAcceptReject',
                    'PublishingJudgesInfoCreate',
                    'PublishingJudgesRewardsRead',
                    'PublishingJudgesRewardsWrite',
                    'PublishingJudgesRewardsDelete',
                    'PublishingJudgesRewardsAcceptReject',
                    'PublishingJudgesRewardsCreate',
                ],
                showInMenu: true,
                isRoute: true,
                id: 1,
                groupName: "essentials",
            },
            {
                path: "/home/judgesManagement/judges/view",
                name: "judgesInfo",
                component: UserProfile,
                icon: "icon-researchers",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [],
                showInMenu: false,
                isRoute: true,
                id: 1,
            },
            {
                path: "/home/judgesManagement/judgeRewards",
                name: "judgesRewards",
                component: JudgesRewardsGridView,
                icon: "icon-dashboard",
                layout: "/home",
                default: false,
                isExact: true,
                authorize: true,
                roles: [
                    'PublishingJudgesRewardsRead',
                    'PublishingJudgesRewardsWrite',
                    'PublishingJudgesRewardsDelete',
                    'PublishingJudgesRewardsAcceptReject',
                    'PublishingJudgesRewardsCreate',
                ],
                showInMenu: true,
                isRoute: true,
            },
        ],
    },
    {
        path: "/home/formTemplates",
        name: "formTemplates",
        component: FormTemplatesGridView,
        icon: "icon-form-builder",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingFormTemplatesRead',
            'PublishingFormTemplatesWrite',
            'PublishingFormTemplatesDelete',
            'PublishingFormTemplatesAcceptReject',
            'PublishingFormTemplatesCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/scientificPublication",
        name: "scientificPublication",
        component: ScientificPublicationGridView,
        // TODO: extract the book icon from FIGMA
        icon: "icon-programs",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingScientificPublicationRead',
            'PublishingScientificPublicationWrite',
            'PublishingScientificPublicationDelete',
            'PublishingScientificPublicationAcceptReject',
            'PublishingScientificPublicationCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/scientificPublication/form",
        name: "scientificPublicationForm",
        component: ScientificPublicationForm,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/scientificPublication/form/:id",
        name: "scientificPublicationForm",
        component: ScientificPublicationForm,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/scientificPublication/:id",
        name: "publicationView",
        component: PublicationView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "",
    },
    {
        path: "/home/evaluationForms",
        name: "evaluationForms",
        component: EvaluationFormsGridView,
        icon: "icon-eval-form",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
            'PublishingEvaluationFormsRead',
            'PublishingEvaluationFormsWrite',
            'PublishingEvaluationFormsDelete',
            'PublishingEvaluationFormsAcceptReject',
            'PublishingEvaluationFormsCreate'
        ],
        showInMenu: true,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/evaluationForms/form",
        name: "",
        component: EvaluationFormAddUpdateView,
        icon: "",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    {
        path: "/home/formTemplates/form",
        name: "",
        component: FormTemplateFormAddUpdateView,
        icon: "",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "essentials",

    },
    {
        path: "/home/editUserProfile/:userId",
        name: "researcherInfo",
        component: EditUserProfileForm,
        icon: "icon-researchers",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/editMyProfile",
        name: "updateMyProfile",
        component: EditUserProfileForm,
        icon: "icon-researchers",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/myProfile",
        name: "myProfile",
        component: UserProfile,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/ScientificPublishingUnitTask/:serialGID",
        name: "ScientificPublishingUnit",
        component: ScientificPublishingUnitOrderView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/UpdateAuthorOrder/:serialGID",
        name: "UpdateAuthorOrder",
        component: UpdateAutherOrderView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },  
    {
        path: "/home/orders/UpdateFileAuthorOrder/:serialGID",
        name: "UpdateFileAuthorOrder",
        component: ()=><UpdateAutherOrderView isFile={true} />,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },    {
        path: "/home/orders/UpdateFileOnlyAuthorOrder/:serialGID",
        name: "UpdateFileOnlyAuthorOrder",
        component: ()=><UpdateAutherOrderView ReadOnly={true} />,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/UpdateAuthorRdmk/:serialGID",
        name: "UpdateAuthorRdmk",
        component: UpdateAuthorRdmkOrderView,
        layout: "/home",
        default: false,
        isExact: true,  
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/ResearchCenterOrder/:serialGID",
        name: "ResearchCenterOrder",
        component: CourseOrderResearchCenterManagerView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/post-announcement/:serialGID",
        name: "PostAnnouncement",
        component: PostAnnouncementOrderView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/tasks/examiner/:serialGID",
        name: "examiner-task",
        component: ExaminerTaskView,
        icon: "",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/PublishingHouseOrder/:serialGID",
        name: "PublishingHouseOrder",
        component: PublishingHouseOrderView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/DisbursementRecommendationOrderView/:serialGID",
        name: "DisbursementRecommendationOrder",
        component: DisbursementRecommendationOrderView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/GenericWorkFlowActions/:serialGID",
        name: "GenericWorkFlowActions",
        component: GenericWorkFlowOrderView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/CourseOrderPublishingHourseOrder/:serialGID",
        name: "CourseOrderPublishingHourseOrderView",
        component: CourseOrderPublishingHourseOrderView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/orders/RefereOrder/:serialGID",
        name: "RefereOrder",
        component: CourseOrderRefereeManagementView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/tasks/Referee/:serialGID",
        name: "Referee",
        component: RefereeTaskView,
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [],
        showInMenu: false,
        isRoute: true,
        id: 1,
    },
    {
        path: "/home/examinerCompletedOrder/:serialGID",
        name: "examinerCompletedOrder",
        component: ()=> <CompletedCourseOrderTaskDetails  />,
        icon: "icon-check-list",
        layout: "/home",
        default: false,
        isExact: true,
        authorize: true,
        roles: [
        
        ],
        showInMenu: false,
        isRoute: true,
        id: 1,
        groupName: "essentials",
    },
    


];
